import { MobileDataTable, type CreditBlotterExposure } from '@talos/kyoko';
import type { CreditTabProps } from '../../../../Blotters/Credit/types';
import { useCreditBlotterFoundation } from '../../../../Blotters/Credit/useCreditBlotterFoundation';
import { MobileBlotterToolbar } from '../MobileBlotterToolbar';
import { MobileCreditCard, useMobileCreditCardLayout } from './MobileCreditCard';
import { MobileCreditGroupCard } from './MobileCreditGroupCard';
import { MobileCreditSettingsToggles } from './MobileCreditSettingsToggles';
import { renderCreditWarningDetails } from './mobileCreditWarnings';

interface MobileFilteredCreditProps {
  blotterID: string;
  tab: CreditTabProps;
  onUpdateTab: (updatedTab: CreditTabProps) => void;
}

export function MobileFilteredCredit({ blotterID, tab, onUpdateTab }: MobileFilteredCreditProps) {
  const { cardHeight, cardRendererProps } = useMobileCreditCardLayout();
  const { blotterTable, filterBuilderAccordion, showZeroBalances, updateShowZeroBalances } = useCreditBlotterFoundation(
    {
      blotterID,
      tab,
      onUpdateTab,
      enableTotals: false,
    }
  );

  return (
    <>
      <MobileBlotterToolbar
        {...filterBuilderAccordion}
        {...blotterTable.blotterTableFiltersProps}
        settingsContent={
          <MobileCreditSettingsToggles
            onShowZeroBalancesToggle={updateShowZeroBalances}
            showZeroBalances={showZeroBalances}
          />
        }
      />
      <MobileDataTable<CreditBlotterExposure>
        {...blotterTable}
        cardRenderer={MobileCreditCard}
        cardRendererProps={cardRendererProps}
        groupCardRenderer={MobileCreditGroupCard}
        cardHeight={cardHeight}
        detailsTitle="Credit Details"
        rowDetailHeader={renderCreditWarningDetails}
      />
    </>
  );
}
